<template>
  <div class="az-carrot-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="97"
      height="97"
      viewBox="0 0 97 97"
      fill="none"
    >
      <g clip-path="url(#clip0_15_1840)">
        <g filter="url(#filter0_d_15_1840)">
          <path
            d="M79.8904 8.74965C78.2401 8.4037 76.2692 8.42853 74.5747 9.66995C74.0411 10.0506 73.6012 10.5505 73.2892 11.1309C72.9772 11.7113 72.8015 12.3566 72.7756 13.0168C72.772 13.2277 72.784 13.4385 72.8116 13.6475C72.9323 14.4421 72.7631 15.254 72.3356 15.9317C72.298 15.9896 72.2604 16.0509 72.2211 16.1105C72.1425 16.228 72.0308 16.3187 71.9004 16.3709C71.7701 16.4231 71.6272 16.4343 71.4904 16.403C71.3537 16.3717 71.2295 16.2994 71.134 16.1956C71.0385 16.0917 70.9762 15.9611 70.9552 15.8208C70.7916 14.7151 70.4138 13.1575 69.4831 11.83C66.7926 7.99983 60.7703 9.91493 60.6084 14.6108C60.5479 16.3505 61.0991 18.5221 62.8557 21.1457C63.4494 22.0219 63.8031 23.0417 63.8806 24.1012C63.9582 25.1607 63.7569 26.2221 63.2973 27.1773C63.0847 27.616 62.8459 28.0745 62.5826 28.5446C62.4723 28.7396 62.4343 28.968 62.4753 29.1888C62.5164 29.4097 62.6339 29.6085 62.8067 29.7496C63.9113 30.6144 64.8946 31.6273 65.7295 32.7604C65.8741 32.9577 66.0895 33.0896 66.3292 33.128C66.5689 33.1664 66.814 33.1081 67.0118 32.9657C67.5482 32.5767 68.0962 32.2109 68.6474 31.8881C69.5399 31.3586 70.5537 31.0744 71.5883 31.0636C72.6228 31.0529 73.6422 31.316 74.5453 31.8269C75.8014 32.5403 77.5401 33.3166 79.3654 33.5003C85.3664 34.0912 86.6258 25.1431 80.6984 24.0274C80.4301 23.9761 80.1456 23.9364 79.8479 23.9066C79.7321 23.8953 79.621 23.8548 79.5247 23.7888C79.4284 23.7229 79.3499 23.6336 79.2964 23.5291C79.2429 23.4247 79.2161 23.3083 79.2185 23.1906C79.2208 23.073 79.2522 22.9578 79.3098 22.8555L79.331 22.8208C79.6198 22.3601 80.0061 21.9702 80.4621 21.6794C80.9182 21.3885 81.4324 21.2039 81.9676 21.1391C82.6954 21.0447 83.7864 20.808 84.681 20.189C85.0577 19.9247 85.3743 19.5822 85.6098 19.1843C85.8453 18.7864 85.9943 18.3423 86.0468 17.8816C86.1005 17.4681 86.1322 17.0521 86.1416 16.6352C86.1773 14.7879 85.571 12.9867 84.4286 11.5456C83.2861 10.1044 81.68 9.11493 79.8904 8.74965Z"
            fill="#008672"
          />
        </g>
        <g filter="url(#filter1_d_15_1840)">
          <path
            d="M63.6678 36.0082C62.0498 33.531 59.7373 31.5997 57.0269 30.4622C54.3166 29.3246 51.3322 29.0327 48.4568 29.624C39.5935 31.4447 32.8762 40.0519 32.8762 40.0519C17.742 57.7761 12.1745 76.6888 10.4146 84.4419C10.3169 84.8701 10.3247 85.316 10.4373 85.7404C10.5499 86.1648 10.7638 86.5547 11.0602 86.8758C11.3567 87.1969 11.7266 87.4393 12.1373 87.5818C12.5481 87.7243 12.9872 87.7624 13.4159 87.6928C35.0695 84.2764 57.8238 60.8218 57.8238 60.8218C65.7777 52.5969 66.8588 45.779 65.7237 40.8266C65.3296 39.1086 64.6332 37.4765 63.6678 36.0082Z"
            fill="#EAA610"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_15_1840"
          x="54.604"
          y="5.55859"
          width="37.5391"
          height="36.9697"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_1840"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_1840"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_15_1840"
          x="4.34668"
          y="26.3257"
          width="67.7559"
          height="70.4009"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_1840"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_1840"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_15_1840">
          <rect
            width="96.285"
            height="96.285"
            fill="white"
            transform="translate(0.183105)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>
